export const placeholderText = [
  {
    id: 1,
    method: 'Interviews (offline), Business meetings (offline)',
    reason:
      'Our users live in constant information flood. Most of that information is noise.',
    instruction:
      "Due to long-term work in informational noise, users' attention is dulled. We should design interfaces in such a way as to reduce the chance of misinterpretation. At every single moment, the user must be very clear on which page he is on and what his actions will lead to.",
    descriptionOfBias: '',
    name: '#1 Availability heuristic',
  },
  {
    id: 2,
    method:
      'Personal discoveries as a result of conducted Business Analysis and many years of working with similar customers',
    reason:
      'Low motivation to make additional steps/ actions. Lack of big picture and consequences.',
    instruction:
      'When the system needs the user to perform some crucial actions, we can afford to design intrusive reminders for these actions.',
    descriptionOfBias: '',
    name: '#10 Omission bias',
  },
  {
    id: 3,
    method: 'Interviews (offline), Business meetings (offline)',
    reason:
      'Users work in highly-bureaucratic environment. Attention to details in texts is numb.',
    instruction:
      'Although the system is highly-bureaucratic, we let ourselves use illustrations and other types of images.',
    descriptionOfBias: '',
    name: '#14  Picture superiority effect',
  },
  {
    id: 4,
    method:
      'Personal discoveries as a result of conducted Business Analysis and many years of working with similar customers',
    reason:
      "Users work in highly-bureaucratic environment. Work nature makes them appreciate any signs of recognition, be it their role name, title, or any other element that's specific to them.",
    instruction:
      "When working with users' attention, we can use a direct appeal to their positions and/or titles. This method should be used in exceptional cases so that calls to action do not look monotonous.",
    descriptionOfBias: '',
    name: '#16 Self-reference effect',
  },
];

export default placeholderText;
